import { render } from "./header.vue?vue&type=template&id=780dea2e"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=780dea2e&lang=scss"

import exportComponent from "F:\\duoji\\vue3\\vue3_demo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__